import React, { useEffect, useMemo, useRef } from 'react';
import { Container, Sprite } from '@pixi/react';
import { Spine } from '../../../core/classes/spine';
import { isMobile } from '../../../core/helpers/isMobile';
import { getGameImages } from '../../../core/helpers/getGameImages';

function GameLogo({ containerConfig }) {
  const gameLogoContainerRef = useRef(null);

  const { gameLogo } = useMemo(() => {
    return getGameImages();
  }, []);

  useEffect(() => {
    if (gameLogoContainerRef.current && !isMobile()) {
      const gameWebLogo = new Spine({ key: 'gameLogo' });
      gameWebLogo.play('idle', true);
      gameLogoContainerRef.current.addChild(gameWebLogo);
    }
  }, [gameLogoContainerRef]);

  return (
    <Container {...containerConfig} ref={gameLogoContainerRef} name='mainBackground'>
      {isMobile() && <Sprite texture={gameLogo} />}
    </Container>
  );
}

export default GameLogo;
